import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { BulkOrderService } from '../../../../SGRE-custom/bulk-order-page/services/bulk-order.service';
import { BulkOrderFetchState } from '../../../../SGRE-custom/bulk-order-page/store/bulk-order.state';
import { CmsParagraphComponent } from '@spartacus/core';

@Component({
    selector: 'app-bulkorder-product-notfound-paragraph',
    templateUrl: './bulkorder-product-notfound-paragraph.component.html',
    styleUrl: './bulkorder-product-notfound-paragraph.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class BulkorderProductNotfoundParagraphComponent {

  /** Old Implementation
  public userRoles: any[];
  role: string;
  productLength: number = 0;
  foundProductLength: boolean = false;
  public componentData: any; */

  /** OOTB Implementation */
  @Input() data: Observable<CmsParagraphComponent>;
  currentpage$: Observable<number>;
  tableData$: Observable<BulkOrderFetchState>;

  constructor(
    private bulkservice: BulkOrderService,
  ) { }

  /** OOTB Implementation */
  ngOnInit(): void {
    this.getCurrentPage();
    this.getTableData();
  }

  getCurrentPage(): void {
    this.currentpage$ = this.bulkservice.getNextValue();
  }

  getTableData(): void {
    this.tableData$ = this.bulkservice.getBulkOrderTableData();
  }

  /** Old Implementation
  ngOnInit(): void {
    this.currentpage$ = this.bulkservice.isNext$;
    this.getUserRole();
    this.getData();
    this.component.data$.subscribe((data) => {
      this.componentData = data;
    });
  }
  getUserRole() {
    this.store.pipe(select(selectUserRoles)).subscribe((userRoles) => {
      this.userRoles = userRoles;
    });
    let userRole: any = ''
    userRole = this.userRoles;
    if (userRole?.includes("Requester") && !userRole?.includes("Purchaser")) {
      this.role = 'Requester';
    }
    else if (userRole?.includes("Purchaser") && !userRole?.includes("Requester")) {
      this.role = 'Purchaser';

    }
    else if (userRole?.includes("Purchaser") && userRole?.includes("Requester")) {
      this.role = 'Purchaser&Requester'
    }
  }

  getData() {
    this.bulkservice.tableDataSubject.subscribe((req) => {
      const data = req
      if (Object.keys(data).length > 0) {
        this.productLength = data?.notFoundProductCodes?.length;
        this.foundProductLength = data?.foundProductCodes?.length === 0 ? true : false
        this.cdRef.markForCheck();
      }
    })
    this.changeRef.markForCheck();
  } */
}
